export const GET_USER_PROFILE = "/api/user/userDetails/";
// Dummy update endpoint for profile edits (multipart)
export const UPDATE_USER_PROFILE_DETAILS = "/api/user/updateDetails";


// Login OTP URL
// export const LOGIN_MOBILE_OTP = "api/getOtp/mobile";
// export const RESET_LOGIN_MOBILE = "api/resendLoginOtp/user";
// export const OTP_VERIFICATION_MOBILE = "api/user/updateMobile";
// export const UPDATE_USER_MOBILE = "api/user/updateMobileNumber";
export const LOGIN_MOBILE_OTP = "api/getOtp/mobile";
export const UPDATE_USER_MOBILE = "api/user/updateMobile";


// export const EMAIL_OTP_GENERATION_URL = "/registration/sendOtpViaEmail";
// export const EMAIL_OTP_VERIFICATION_URL = "/registration/verifyEmailOtp";
// export const UPDATE_USER_EMAIL = "api/user/updateEmail";
export const EMAIL_OTP_GENERATION_URL = "/api/getOtp/email";
export const UPDATE_USER_EMAIL = "api/user/updateEmail";

// export const EMAIL_OTP_GENERATION_URL = "/api/sendOTPVerificationEmail";
// export const EMAIL_OTP_VERIFICATION_URL = "/api/sendOTPVerificationEmail";

export const UPLOAD_DOCUMENT = "/api/user/uploadDocument"
export const CHECK_UPDATE_URL = "/api/user/checkUpdate";
export const GET_KIT_SIZES = "/api/user/getKitSizes";
export const GET_STATE_URL = "/api/state";
export const GET_DISTRICT_URL = "/api/district";
export const UPDATE_PROFILE_LIST_URL = "/api/user/updateProfileList";
export const UPDATE_USER_EMAIL_DIRECT = "api/user/updateEmailDirect";
export const CHANGE_PASSWORD_URL = "api/user/changePassword";
export const GET_USER_CATEGORY_MAIN = "api/user/getUserCategoryMain";
export const UPDATE_USER_TYPE_URL = "api/user/updateUserType";
